import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: {
        title: '报名',
        meta: [],
      },
    },
    {
      path: '/home',
      name: 'home',
      component: () =>
        import(/* webpackChunkName: "Home" */ '../pages/home.vue'),
      meta: {
        title: '报名',
        meta: [],
      },
    },
    {
      path: '/apply/detail',
      name: 'applyDetail',
      component: resolve =>
        require(['@/pages/apply/view/applyDetail'], resolve),
      meta: {
        title: '报名详情',
        meta: [],
      },
    },
    {
      path: '/apply/cover',
      name: 'applyCover',
      component: resolve => require(['@/pages/apply/view/applyCover'], resolve),
      meta: {
        title: '报名封面',
        meta: [],
      },
    },
    {
      path: '/apply/invoice',
      name: 'applyInvoice',
      component: resolve => require(['@/pages/apply/view/applyInvoice'], resolve),
      meta: {
        title: '发票抽奖',
        meta: [],
      },
    },
    {
      path: '/apply/invoice/list',
      name: 'applyInvoiceList',
      component: resolve => require(['@/pages/apply/view/applyInvoiceList'], resolve),
      meta: {
        title: '抽奖活动',
        meta: [],
      },
    },
    {
      path: '/apply/invoice/win',
      name: 'applyInvoiceWin',
      component: resolve => require(['@/pages/apply/view/applyInvoiceWin'], resolve),
      meta: {
        title: '中奖记录',
        meta: [],
      },
    },
    {
      path: '/apply/invoice/info',
      name: 'applyInvoiceForm',
      component: resolve => require(['@/pages/apply/view/invoiceInfo'], resolve),
      meta: {
        title: '领取奖品',
        meta: [],
      },
    },
    {
      path: '/apply/invoice/form',
      name: 'applyInvoiceWin',
      component: resolve => require(['@/pages/apply/view/invoiceForm'], resolve),
      meta: {
        title: '',
        meta: [],
      },
    },
    {
      path: '/apply/event',
      name: 'applyEvent',
      component: resolve => require(['@/pages/apply/view/applyEvent'], resolve),
      meta: {
        title: '赛事活动',
        meta: [],
      },
    },
    {
      path: '/apply/event/list',
      name: 'applyEventList',
      component: resolve => require(['@/pages/apply/view/applyEventList'], resolve),
      meta: {
        title: '赛事活动',
        meta: [],
      },
    },
    {
      path: '/apply/event/win',
      name: 'applyEventWin',
      component: resolve => require(['@/pages/apply/view/applyEventWin'], resolve),
      meta: {
        title: '报名记录',
        meta: [],
      },
    },
    {
      path: '/apply/result',
      name: 'applySuccess',
      component: resolve =>
        require(['@/pages/apply/view/applySuccess'], resolve),
      meta: {
        title: '报名结果页',
        meta: [],
      },
    },
    // 核销页面
    {
      path: '/verify/bindPhone',
      name: 'bindPhone',
      component: resolve => require(['@/pages/verify/bindPhone'], resolve),
      meta: {
        title: '绑定手机号',
        meta: [],
      },
    },
    {
      path: '/verify/index',
      name: 'verify',
      component: resolve => require(['@/pages/verify/index'], resolve),
      meta: {
        title: '报名核销',
        meta: [],
      },
    },
    {
      path: '/verify/records',
      name: 'verify',
      component: resolve => require(['@/pages/verify/records'], resolve),
      meta: {
        title: '报名核销',
        meta: [],
      },
    },
    {
      path: '/form/view',
      name: 'formView',
      component: resolve => require(['@/pages/form/view/formView'], resolve),
      meta: {
        title: '信息填写',
        meta: [],
      },
    },
    {
      path: '/record/index',
      name: 'record',
      component: resolve => require(['@/pages/record/index'], resolve),
      meta: {
        title: '参与记录',
        meta: [],
      },
    },
    {
      path: '/error',
      component: resolve =>
        require(['@/components/view/connotAccess.vue'], resolve),
      name: 'connotAccess',
      meta: {
        title: '您无法访问',
        meta: [],
      },
    },
    {
      path: '/noLonger',
      component: resolve =>
        require(['@/components/view/noLonger.vue'], resolve),
      name: 'noLonger',
      meta: {
        title: '活动已下线',
        meta: [],
      },
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js